<template>
  <div v-bar class="vs-scrollable">
    <div>
      <div class="con-exemple-prompt px-4 py-3">
        <vs-input
          :danger="errors.counter.name"
          :danger-text="
            $t('Errors.InvalidPolite', {
              field: $t('Queue.Create.CounterName'),
            })
          "
          :label="$t('Queue.Create.CounterName')"
          v-model="selected.name"
          class="w-100 mb-4"
        />
        <!-- <vs-select
          :placeholder="'Services related to queue'"
          class="w-100 mb-4"
          :label="'Services related to queue'"
          autocomplete
          multiple
          v-model="servicesCounter"
        >
          <vs-select-item
            :key="index"
            :value="item.id"
            :text="item.name"
            v-for="(item, index) in servicesList"
          />
        </vs-select> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Counter",
  data: () => ({}),
  props: {
    errors: Object,
    selected: Object,
    servicesCounter: Array,
    servicesList: Array,
  },
  methods: {},
};
</script>